import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Divider, FormHelperText, Grid, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import { addNewRole, getRoleDetails, resetRoleState, updateRole } from "../../../store/role/action";
import Notification from "../../../components/Common/Notification";
import LoadingDialog from "../../../components/Common/LoadingDialog";
import CustomTextField from "../../../components/Form/CustomTextField";
import CheckBox from "../../../components/Form/CheckBox";
import { Checkbox as MuiCheckbox } from "@mui/material";
import CustomButton from "../../../components/Form/CustomButton";
import { getPermissionListing } from "../../../store/permission/actions";
import { getGeneral, verify_admin } from "../../../store/actions";


const AddRoleAndPermission = ({ type, title, permissionList, addRole, roleDetails, editRole, userPermission, submitError }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { ID } = useParams();

  useEffect(() => {
    dispatch(resetRoleState());
    dispatch(getPermissionListing());
    if (type === 'Edit') {
      dispatch(getRoleDetails({ id: ID }));
    }

    const handleResize = () => {
      setWidth(window.innerWidth); // Update state when window resizes
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup on unmount
      dispatch(resetRoleState());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [loading, setIsLoading] = useState(false);
  const [selectAll, setSelectAll] = useState();
  const [productsPermission, setProductPermission] = useState({});
  const [ordersPermission, setOrdersPermission] = useState({});
  const [settingPermission, setSettingPermission] = useState({});
  const [supportPermission, setSupportPermission] = useState({});
  const [customersPermission, setCustomersPermission] = useState({});
  const [marketingPermission, setMarketingPermission] = useState({});
  const [inventoryPermission, setInventoryPermission] = useState({});
  const [reviewsPermission, setReviewsPermission] = useState({});
  const [reportPermission, setReportPermission] = useState({});
  const [width, setWidth] = useState(window.innerWidth);
  const [notification, setNotification] = useState({
    open: false,
    msg: "",
    type: "success",
  });
  const error = submitError?.[0];

  useEffect(() => {
    if (userPermission?.length > 0) {
      if (type === "Add")
        !userPermission?.includes("view-setting") && navigate('/not-authorized');
      else if (type === "Edit")
        !userPermission?.includes("edit-setting") && navigate('/not-authorized');
    }
  }, [userPermission])

  useEffect(() => {
    if (addRole?.code === 'success') {
      setNotification({
        open: true,
        msg: 'Role added successfully',
        type: 'success'
      })
      dispatch(getGeneral());
      dispatch(verify_admin());
      navigate('/settings-roles');
    }
  }, [addRole])

  useEffect(() => {
    if (editRole?.code === 'success') {
      setNotification({
        open: true,
        msg: 'Role edited successfully',
        type: 'success'
      })
      dispatch(resetRoleState());
      dispatch(getGeneral());
      dispatch(verify_admin());
      dispatch(getRoleDetails({ id: ID }));
    }
  }, [editRole])

  useEffect(() => {
    if (permissionList?.length > 0) {
      setIsLoading(true);
      handleSetPermissionData();
    }
    if (type === 'Edit') {
      values.name = roleDetails?.display_name || '';
      values.description = roleDetails?.description || '';
      setFormValues({ ...values });
      handleSetUserPermissionData();
    }
  }, [permissionList, roleDetails])

  const handleSubmit = () => {
    setIsLoading(true);

    let payload = {
      display_name: values?.name || '',
      description: values?.description || '',
      permissions: {}
    }
    Object.keys(productsPermission).forEach(key => {
      payload.permissions[`${key}-product`] = productsPermission[key];
    });
    Object.keys(ordersPermission).forEach(key => {
      payload.permissions[`${key}-order`] = ordersPermission[key];
    });
    Object.keys(inventoryPermission).forEach(key => {
      payload.permissions[`${key}-inventory`] = inventoryPermission[key];
    });
    Object.keys(customersPermission).forEach(key => {
      payload.permissions[`${key}-customer`] = customersPermission[key];
    });
    Object.keys(marketingPermission).forEach(key => {
      payload.permissions[`${key}-marketing`] = marketingPermission[key];
    });
    Object.keys(reviewsPermission).forEach(key => {
      payload.permissions[`${key}-review`] = reviewsPermission[key];
    });
    Object.keys(settingPermission).forEach(key => {
      payload.permissions[`${key}-setting`] = settingPermission[key];
    });
    Object.keys(reportPermission).forEach(key => {
      payload.permissions[`${key}-reporting`] = reportPermission[key];
    });
    Object.keys(supportPermission).forEach(key => {
      payload.permissions[`${key}-support`] = supportPermission[key];
    });
    if (type === "Add") {
      dispatch(addNewRole(payload));
    }
    else if (type === "Edit") {
      dispatch(updateRole({ id: ID, role: payload }));
    }
    setIsLoading(false);

  }

  const [values, setFormValues] = useState({})

  useEffect(() => {
    if (selectAll === true || selectAll === false) {
      Object.keys(productsPermission).forEach(key => {
        productsPermission[key] = selectAll;
      });
      Object.keys(ordersPermission).forEach(key => {
        ordersPermission[key] = selectAll;
      });
      Object.keys(customersPermission).forEach(key => {
        customersPermission[key] = selectAll;
      });
      Object.keys(marketingPermission).forEach(key => {
        marketingPermission[key] = selectAll;
      });
      Object.keys(reviewsPermission).forEach(key => {
        reviewsPermission[key] = selectAll;
      });
      Object.keys(inventoryPermission).forEach(key => {
        inventoryPermission[key] = selectAll;
      });
      Object.keys(reportPermission).forEach(key => {
        reportPermission[key] = selectAll;
      });
      Object.keys(settingPermission).forEach(key => {
        settingPermission[key] = selectAll;
      });
      Object.keys(supportPermission).forEach(key => {
        supportPermission[key] = selectAll;
      });
      setProductPermission({ ...productsPermission });
      setOrdersPermission({ ...ordersPermission });
      setSupportPermission({ ...supportPermission });
      setInventoryPermission({ ...inventoryPermission });
      setCustomersPermission({ ...customersPermission });
      setMarketingPermission({ ...marketingPermission });
      setReviewsPermission({ ...reviewsPermission });
      setSettingPermission({ ...settingPermission });
      setReportPermission({ ...reportPermission });
    }
  }, [selectAll])

  const handleValueChange = (dataObj, field, val, setDataObj) => {
    setDataObj({ ...dataObj, [field]: val });
  }

  const handleSetPermissionData = () => {
    permissionList.map((item) => {
      let module = item.name.split('-')[1];
      let permission = item.name.split('-')[0];
      if (module === 'product') {
        productsPermission[permission] = false;
      } else if (module === 'order') {
        ordersPermission[permission] = false;
      } else if (module === 'support') {
        supportPermission[permission] = false;
      } else if (module === 'inventory') {
        inventoryPermission[permission] = false;
      } else if (module === 'customer') {
        customersPermission[permission] = false;
      } else if (module === 'marketing') {
        marketingPermission[permission] = false;
      } else if (module === 'review') {
        reviewsPermission[permission] = false;
      } else if (module === 'setting') {
        settingPermission[permission] = false;
      } else if (module === 'reporting') {
        reportPermission[permission] = false;
      }
    })
    setProductPermission({ ...productsPermission });
    setOrdersPermission({ ...ordersPermission });
    setSupportPermission({ ...supportPermission });
    setInventoryPermission({ ...inventoryPermission });
    setCustomersPermission({ ...customersPermission });
    setMarketingPermission({ ...marketingPermission });
    setReviewsPermission({ ...reviewsPermission });
    setSettingPermission({ ...settingPermission });
    setReportPermission({ ...reportPermission });
    setIsLoading(false);
  }

  const handleSetUserPermissionData = () => {
    roleDetails?.permissions?.length > 0 && roleDetails.permissions.map((item) => {
      let module = item.name.split('-')[1];
      let permission = item.name.split('-')[0];
      if (module === 'product') {
        productsPermission[permission] = true;
      } else if (module === 'order') {
        ordersPermission[permission] = true;
      } else if (module === 'support') {
        supportPermission[permission] = true;
      } else if (module === 'inventory') {
        inventoryPermission[permission] = true;
      } else if (module === 'customer') {
        customersPermission[permission] = true;
      } else if (module === 'marketing') {
        marketingPermission[permission] = true;
      } else if (module === 'review') {
        reviewsPermission[permission] = true;
      } else if (module === 'setting') {
        settingPermission[permission] = true;
      } else if (module === 'reporting') {
        reportPermission[permission] = true;
      }
    })
    setProductPermission({ ...productsPermission });
    setOrdersPermission({ ...ordersPermission });
    setSupportPermission({ ...supportPermission });
    setInventoryPermission({ ...inventoryPermission });
    setCustomersPermission({ ...customersPermission });
    setMarketingPermission({ ...marketingPermission });
    setReviewsPermission({ ...reviewsPermission });
    setSettingPermission({ ...settingPermission });
    setReportPermission({ ...reportPermission });
    setIsLoading(false);
  }

  const renderTableCell = (values, dataObj, action, setDataObj) => {
    return (
      <TableCell sx={{ textAlign: 'center' }}>
        {
          values !== undefined &&
          <MuiCheckbox
            checked={values}
            onChange={(e) => { handleValueChange(dataObj, action, e.target.checked, setDataObj) }}
            sx={{
              color: '#D0D0D0',
              '&.Mui-checked': {
                color: '#ED1A3D',
              },
            }}
          />
        }
      </TableCell>
    )
  }

  const renderTableRow = (module, dataObj, setDataObj) => {
    return (
      <TableRow
        key={module}
        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
      >
        <TableCell style={{ fontFamily: 'Manrope' }}>{module}</TableCell>
        {renderTableCell(dataObj?.view, dataObj, 'view', setDataObj)}
        {renderTableCell(dataObj?.create, dataObj, 'create', setDataObj)}
        {renderTableCell(dataObj?.edit, dataObj, 'edit', setDataObj)}
        {renderTableCell(dataObj?.delete, dataObj, 'delete', setDataObj)}
        {renderTableCell(dataObj?.export, dataObj, 'export', setDataObj)}
        {renderTableCell(dataObj?.approve, dataObj, 'approve', setDataObj)}
      </TableRow>
    )
  }
  return (
    <React.Fragment>
      {
        width <= 425 &&
        <div className="mobile-button-container">
          <CustomButton
            title={type === 'Add' ? 'Save' : 'Save Changes'}
            press={() => handleSubmit()}
            backgroundColor={'#101010'}
            textColor={'white'}
            width={'100%'}
          />
        </div>
      }
      <div className="page-content">
        <LoadingDialog open={loading || !productsPermission} />
        <Container fluid>
          <Notification notification={notification} setNotification={setNotification} />
          <Breadcrumbs
            backRoute="/settings-roles"
            breadcrumbItems={[{ title: "Roles", link: "/settings-roles" },
            { title: title, link: "#" },
            ]}
          >
            {
              width > 425 &&
              <CustomButton
                title={type === 'Add' ? 'Save' : 'Save Changes'}
                press={() => handleSubmit()}
                backgroundColor={'#101010'}
                textColor={'white'}
              />
            }
          </Breadcrumbs>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={10} pb={3}>
              <Card className="p-3 px-2">
                <CardBody>
                  <div className="setting-header">BASIC INFO</div>
                  <Divider className="my-2 mb-4" />
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <CustomTextField
                        title={'Role name'}
                        values={values?.name}
                        placeholder="Eg. Admin"
                        subtitle={'Keep it short and straightforward.'}
                        onChange={(e) => setFormValues((prevValues) => ({
                          ...prevValues,
                          name: e
                        }))}
                      />
                      {error && <FormHelperText sx={{ color: "red" }}>{error?.display_name || ""}</FormHelperText>}
                    </Grid>

                    <Grid item xs={12}>
                      <CustomTextField
                        title={'Description'}
                        values={values?.description}
                        placeholder="Briefly description of the role's main responsibilities."
                        onChange={(e) => setFormValues((prevValues) => ({
                          ...prevValues,
                          description: e
                        }))}
                        multiline={true}
                        rows={4}
                      />
                      {error && <FormHelperText sx={{ color: "red" }}>{error?.description || ""}</FormHelperText>}
                    </Grid>
                  </Grid>
                </CardBody>
              </Card>
              <Card className="p-3 px-2">
                <CardBody>
                  <Grid item xs={12}>
                    <div className="setting-header d-flex justify-content-between">
                      PERMISSIONS
                      <CheckBox
                        title={'SelectAll'}
                        values={selectAll}
                        label={'Select All'}
                        onChange={(e) => { setSelectAll(e.target.checked) }}
                      />
                    </div>
                    <Divider className="mt-1 mb-4" />
                  </Grid>
                  {/* role */}
                  <Grid item xs={12}>
                    <Table style={{ border: '1px solid #D0D0D0' }}>
                      <TableHead style={{ backgroundColor: '#F9F9F9' }}>
                        <TableRow style={{ fontFamily: 'Manrope-SemiBold' }}>
                          <TableCell style={{ fontFamily: 'Manrope-SemiBold' }}>Module</TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>View</TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>Add</TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>Edit</TableCell>
                          <TableCell sx={{ textAlign: 'center' }} >Delete</TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>Export</TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>Approval</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {renderTableRow('Products', productsPermission, setProductPermission)}
                        {renderTableRow('Orders', ordersPermission, setOrdersPermission)}
                        {renderTableRow('Inventory', inventoryPermission, setInventoryPermission)}
                        {renderTableRow('Customers', customersPermission, setCustomersPermission)}
                        {renderTableRow('Marketing', marketingPermission, setMarketingPermission)}
                        {renderTableRow('Reviews', reviewsPermission, setReviewsPermission)}
                        {renderTableRow('Settings', settingPermission, setSettingPermission)}
                        {renderTableRow('Reporting', reportPermission, setReportPermission)}
                        {renderTableRow('Support', supportPermission, setSupportPermission)}
                      </TableBody>
                    </Table>
                  </Grid>
                </CardBody>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </div>
    </React.Fragment >
  );
};

function mapStateToProps({ Permission, Role, Login }) {
  return {
    roleListing: Role.roleListing,
    roleDetails: Role.roleDetails,
    userPermission: Login.permissionArry,
    addRole: Role.addRole,
    editRole: Role.editRole,
    submitError: Role.error,
    permissionList: Permission.permissionListing.data,
  };
}

export default connect(mapStateToProps)(AddRoleAndPermission);
